export default "__VITE_ASSET__0313384d__"